var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('div',{staticClass:"text-center tw-my-10"},[_c('i',{staticClass:"fas fa-spinner fa-spin fa-2x"})]):_vm._e(),_vm._v(" "),(_vm.startLoading)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }